import { render, staticRenderFns } from "./SearchDashboard.vue?vue&type=template&id=763b15f8&lang=html"
import script from "./SearchDashboard.vue?vue&type=script&lang=js"
export * from "./SearchDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports